import Vue from "vue";

Vue.filter("nameShorten", (value) => {
      return value && value != '' && value
        .split(" ")
        .map((c, i) => i == 0 ? c : c[0]+'.')
        .join(" ")
});
